import { EQUIPMENT_QUALITY_CATEGORIES_MAP, EQUIPMENT_STATUSES } from '_constants/equipments'

export const EQUIPMENT_QUALITY_CATEGORIES_OPTIONS = Object.values(EQUIPMENT_QUALITY_CATEGORIES_MAP)

export const PAGE_SIZE_OPTIONS = [
  { label: '5', value: 5 },
  { label: '10', value: 10 },
  { label: '25', value: 25 },
]

export const STATUS_CHIP_LABEL_KEYS = {
  [EQUIPMENT_STATUSES.AVAILABLE]: 'checkIn:equipments.manageEquipments.ready',
  [EQUIPMENT_STATUSES.IN_USE]: 'checkIn:equipments.assignToEquipment.inUse',
  [EQUIPMENT_STATUSES.DELAY]: 'checkIn:equipments.assignToEquipment.inUse',
  [EQUIPMENT_STATUSES.DIRTY]: 'checkIn:equipments.assignToEquipment.dirty',
  [EQUIPMENT_STATUSES.ERROR]: 'checkIn:equipments.manageEquipments.unavailable',
  [EQUIPMENT_STATUSES.DISABLED]: 'checkIn:equipments.manageEquipments.unavailable',
}
